<div class="dashboard-container">
  <!-- Mobile Header -->
  <div class="mobile-header d-lg-none">
    <button class="btn btn-danger" (click)="toggleSidebar()">
      <i class="bi bi-list"></i>
    </button>
    <div class="logo">
      <a href="/">
      <img src="assets/images/SmartDukaan_Logo_Transparent.png" alt="Smart Dukaan Logo" style="width:100px !important;">
      </a>
    </div>
    <div class="user-avatar">AG</div>
  </div>

  <!-- Sidebar -->
  <div class="sidebar" [class.collapsed]="sidebarCollapsed" [class.mobile-open]="sidebarCollapsed">
    <div class="sidebar-header">
      <div class="logo">
        <a href="">
        <img src="assets/images/SmartDukaan_Logo_Transparent.png" alt="Smart Dukaan Logo" style="width:100px !important;">
        </a>
      </div>
      <button class="btn btn-sm btn-outline-danger d-lg-none close-btn" (click)="toggleSidebar()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="sidebar-menu">
      <div class="menu-title">MAIN</div>

      <a routerLink="dashboard"
         routerLinkActive="active"
         class="menu-item"
         (click)="closeMobileSidebar()">
        <i class="bi bi-house-door"></i>
        <span>Dashboard</span>
      </a>
      <a routerLink="/user/profile"
         routerLinkActive="active"
         class="menu-item"
         (click)="closeMobileSidebar()">
        <i class="bi bi-person"></i>
        <span>Customer Profile</span>
      </a>

      <a routerLink="earning"
         routerLinkActive="active"
         class="menu-item"
         (click)="closeMobileSidebar()">
        <i class="bi bi-wallet2"></i>
        <span>Earnings</span>
      </a>

      <a routerLink="links"
         routerLinkActive="active"
         class="menu-item"
         (click)="closeMobileSidebar()">
        <i class="bi bi-link-45deg"></i>
        <span>Affiliate Links</span>
      </a>

      <a routerLink="products"
         routerLinkActive="active"
         class="menu-item"
         (click)="closeMobileSidebar()">
        <i class="bi bi-box-seam"></i>
        <span>Products</span>
      </a>
      <a routerLink="referral"
         routerLinkActive="active"
         class="menu-item"
         (click)="closeMobileSidebar()">
        <i class="bi bi-people"></i>
        <span>Referral</span>
      </a>

    </div>

    <div class="sidebar-footer">
      <div class="user-profile">
        <div class="avatar bg-danger">{{userCode}}</div>
        <div class="user-info">
          <strong >{{customer.firstName}}{{customer.lastName}}</strong>
          <small >SmartSeller ID: <span class="fw-bold">{{userCode}}{{customer.id}}</span></small>
        </div>
      </div>
    </div>
  </div>

  <!-- Overlay for mobile -->
  <div class="sidebar-overlay"
       [class.show]="sidebarCollapsed"
       (click)="toggleSidebar()"></div>

  <!-- Main Content Area -->
  <div class="main-content" [class.sidebar-collapsed]="sidebarCollapsed">
    <div class="content-container">
      <app-header [headersHeading]="headerHeading"></app-header>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<footer class="d-md-none d-block fixed-bottom z-3">
  <nav class="nav-icons-container">
    <ul class="list-unstyled d-flex justify-content-around m-0 p-0">
      <li [ngClass]="{'active': selectedMenu == '/associates/dashboard'}" (click)="makeActive('/associates/dashboard')" routerLink="dashboard"
          routerLinkActive="active">
        <i class="pi pi-home"></i>
      </li>
      <li [ngClass]="{'active': selectedMenu == '/associates/earning'}" (click)="makeActive('/associates/earning')" routerLink="earning"
          routerLinkActive="active">
        <i class="pi pi-wallet"></i>
      </li>
      <li [ngClass]="{'active': selectedMenu == '/associates/links'}" (click)="makeActive('/associates/links')" routerLink="links"
          routerLinkActive="active">
        <i class="pi pi-link"></i>
      </li>
      <li [ngClass]="{'active': selectedMenu == '/associates/products'}" (click)="makeActive('/associates/products')" routerLink="products"
          routerLinkActive="active">
        <i class="pi pi-box"></i>
      </li>
      <li [ngClass]="{'active': selectedMenu == '/user/profile'}" (click)="makeActive('/user/profile')" routerLink="profile"
          routerLinkActive="active" >
        <i class="pi pi-user"></i>
      </li>
    </ul>
  </nav>
</footer>
